<template>
  <ToggleSection label="Spike-ins" :collapsed="!dv.isEditing && !showSection">
    <FieldGrid
      class="form-fields"
      :fields="[['spike_in_kit_name', 'spike_in_dilution']]"
      :dv="dv"
    />
  </ToggleSection>
</template>

<script>
import { computed } from 'vue'
import ToggleSection from '@/components/fields/ToggleSection.vue'
import FieldGrid from '@/components/fields/FieldGrid.vue'

export default {
  name: 'SampleSpikeIns',
  components: { ToggleSection, FieldGrid },
  props: {
    dv: { type: Object, required: true },
  },
  setup(props) {
    const showSection = computed(
      () =>
        props.dv.editedRecord?.['spike_in_kit_name']?.value?.length > 0 ||
        props.dv.editedRecord?.['spike_in_dilution']?.value?.length > 0,
    )

    return { showSection }
  },
}
</script>
